function lightboxes() {

    $.fancybox.defaults.animationEffect = "fade";
    $.fancybox.defaults.transitionEffect = "fade";
    $.fancybox.defaults.transitionDuration = "400";

    if ( $('.lineup-list').length && $(window).width() > 1024) {
        $(document).on('afterShow.fb', function() {
            $.fancybox.getInstance().update();
            $('.fancybox-button--zoom').trigger('click');
        });
    }

    $('[data-fancybox="videos"]').fancybox({
        media : {
            youtube : {
                params : {
                    autoplay : 1,
                    fs : 1,
                    iv_load_policy : 3,
                    rel : 0,
                    showinfo : 0,
                    showsearch : 0,
                    modestbranding : 1,
                    color : 'white'
                }
            }
        }
    });

    $('[data-fancybox="iframe"]').fancybox({
        type : 'iframe'
    });

    $('[data-fancybox="inline"]').fancybox({
        type: 'inline'
    });

    $('[data-fancybox="gallery"]').fancybox({
        animationEffect: "zoom",
        thumbs: {
            autoStart : false
        },
        buttons: ["download", "slideShow", "fullScreen", "thumbs", "close"],
        autoplay: false,
        infobar: true,
        slideShow: {
            autoStart: false,
            speed: 3500
        }

    });

    $('[data-fancybox="weekly-lineup"]').fancybox({
        animationEffect: "zoom",
        hash: false,
        thumbs: {
            autoStart : false
        },
        buttons: ["download", "slideShow", "fullScreen", "thumbs", "close"],
        autoplay: false,
        infobar: true,
        slideShow: {
            autoStart: false,
            speed: 3500
        }

    });

    $('[data-fancybox="slideshow"]').fancybox({
        animationEffect: "fade",
        thumbs: {
            autoStart : true
        },
        buttons: ["zoom", "slideShow", "fullScreen", "download", "thumbs", "close"],
        autoplay: true,
        infobar: true,
        slideShow: {
            autoStart: true,
            speed: 3500
        }

    });

    $('[data-fancybox="zoom"]').fancybox({
        animationEffect: false,
        transitionEffect: false,
        infobar: true,
        afterShow : function( instance, current ) {
            console.info( instance );
        }
    });

    $('[data-fancybox]').filter(function() {
            return $(this).attr('data-fancybox') === '';
        })
        .fancybox({
            animationEffect: "fade",
            buttons: ["zoom", "fullScreen",  "download", "close"],
        });

    $(document).on('afterShow.fb', function( e, instance, slide ) {
        // zoom after load

        if ( !! $('#newhomeevent').length ) {
            $('#newhomeevent').trigger('focus');
        }
        if ( !! $('#delete_reason').length ) {
            $('#delete_reason').trigger('focus');
        }

    });


    // Support Legacy Lightbox Calls
    $('.lightbox').attr('data-fancybox', 'images');
    $('.lightbox-video').attr('data-fancybox', 'videos');
    $('.iframelbx').attr('data-fancybox', '');
    $('.iframelbx').attr('data-type', 'iframe');
    $('.lightbox-gal').attr('data-fancybox', 'gallery');

    // Remove Duplicate Video From Slideshow
    if ( $('[data-fancybox="videos"]').length ) {

        $('.cycle-sentinel a').removeAttr('data-fancybox');
        $( '.umftv ul' ).on( 'cycle-before', function( event, opts ) {
            $('.cycle-sentinel a').removeAttr('data-fancybox');
        });
    }

    var novid = getUrlParam('novid');
    if ( !! $('.autovid').length && !novid ) {
        $('.autovid').trigger('click');
    }
}
